import { render, staticRenderFns } from "./report-device.vue?vue&type=template&id=22d715f6"
import script from "./report-device.vue?vue&type=script&lang=js"
export * from "./report-device.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports